import {
  Cpu,
  Briefcase,
  Crown,
  Layers,
  Workflow,
  Award,
  Code2,
  MapPin,
  BadgeCheck,
  Handshake,
  Building2,
  Cloud,
  Landmark,
  Factory,
  Cog,
  ShoppingCart,
  Truck,
  HeartPulse,
  Store,
  Scale,
  Building,
} from "lucide-react";

export const SERVICES = [
  {
    num: "01",
    id: "it-recruitment",
    icon: Cpu,
    title: "IT Recruitment",
    tag: "Technology Hiring",
    desc: "Hiring technology professionals across the full engineering and digital spectrum.",
    items: [
      "Software Development",
      "Data & Analytics",
      "Cloud & DevOps",
      "Cybersecurity",
      "IT Infrastructure",
      "QA & Testing",
      "Project & Product Management",
      "Other technology functions",
    ],
  },
  {
    num: "02",
    id: "non-it-recruitment",
    icon: Briefcase,
    title: "Non-IT Recruitment",
    tag: "Corporate Functions",
    desc: "Recruitment support across core business and corporate functions.",
    items: [
      "Sales & Business Development",
      "Finance & Accounting",
      "Human Resources",
      "Operations",
      "Supply Chain",
      "Manufacturing",
      "Procurement",
      "Administration",
      "Other corporate functions",
    ],
  },
  {
    num: "03",
    id: "leadership-hiring",
    icon: Crown,
    title: "Leadership Hiring",
    tag: "Executive Search",
    desc: "Specialised recruitment support for senior and business-critical leadership mandates.",
    items: ["Managers", "Senior Managers", "Functional Heads", "CXO / Leadership positions"],
  },
  {
    num: "04",
    id: "volume-hiring",
    icon: Layers,
    title: "Volume Hiring",
    tag: "Scale & Speed",
    desc: "Structured recruitment support for organisations with multiple open positions and aggressive hiring timelines.",
    items: ["Multiple open positions", "Aggressive timelines", "Structured process", "Consistent quality"],
  },
  {
    num: "05",
    id: "end-to-end-recruitment",
    icon: Workflow,
    title: "End-to-End Recruitment",
    tag: "Full Lifecycle",
    desc: "Support throughout the entire hiring lifecycle, from first briefing to joining follow-up.",
    flow: [
      "Requirement Understanding",
      "Sourcing",
      "Screening",
      "Shortlisting",
      "Interview Coordination",
      "Offer Management",
      "Joining Follow-up",
    ],
  },
];

export const WHY_POINTS = [
  { icon: Award, title: "Deep Recruitment Expertise", desc: "9+ years of hands-on recruitment and talent acquisition experience." },
  { icon: Code2, title: "IT & Non-IT Expertise", desc: "Understanding of technology as well as business and corporate hiring requirements." },
  { icon: MapPin, title: "PAN India Reach", desc: "Recruitment support across major talent markets throughout India." },
  { icon: BadgeCheck, title: "Quality-Focused Hiring", desc: "Focus on relevant, qualified and carefully screened candidates." },
  { icon: Handshake, title: "Stakeholder Partnership", desc: "We work closely with hiring managers and business stakeholders to understand the actual requirement." },
  { icon: Building2, title: "MNC Recruitment Experience", desc: "Experience supporting recruitment requirements for MNC and Fortune 500 environments." },
];

export const PROCESS_STEPS = [
  { num: "01", name: "Understand", desc: "Understand the role, organisation, culture and hiring requirement." },
  { num: "02", name: "Source", desc: "Identify relevant candidates through multiple sourcing channels." },
  { num: "03", name: "Screen", desc: "Evaluate candidates against the required skills, experience and role expectations." },
  { num: "04", name: "Shortlist", desc: "Present relevant candidates with structured candidate information." },
  { num: "05", name: "Coordinate", desc: "Manage interview scheduling and communication between candidates and stakeholders." },
  { num: "06", name: "Close", desc: "Support offer discussions, candidate engagement and joining follow-up." },
];

export const INDUSTRIES = [
  { icon: Cpu, name: "Information Technology" },
  { icon: Cloud, name: "Software & SaaS" },
  { icon: Landmark, name: "Banking & Financial Services" },
  { icon: Scale, name: "Consulting" },
  { icon: Factory, name: "Manufacturing" },
  { icon: Cog, name: "Engineering" },
  { icon: ShoppingCart, name: "E-commerce" },
  { icon: Truck, name: "Logistics & Supply Chain" },
  { icon: HeartPulse, name: "Healthcare" },
  { icon: Store, name: "Retail" },
  { icon: Briefcase, name: "Professional Services" },
  { icon: Building, name: "Other Corporate Functions" },
];

export const FAQS = [
  {
    q: "What recruitment services does Talentify provide?",
    a: "Talentify provides IT recruitment, Non-IT recruitment, leadership hiring, volume hiring and end-to-end recruitment support for organisations across PAN India.",
  },
  {
    q: "Does Talentify support both IT and Non-IT recruitment?",
    a: "Yes. We hire technology professionals across software, data, cloud, cybersecurity, infrastructure and product functions, as well as talent across sales, finance, HR, operations, supply chain, manufacturing, procurement and other corporate functions.",
  },
  {
    q: "Does Talentify provide recruitment support across India?",
    a: "Yes. We support recruitment requirements across PAN India, covering all major talent markets and locations throughout the country.",
  },
  {
    q: "What types of positions can Talentify recruit for?",
    a: "We recruit across levels and functions — from niche specialist and individual contributor roles to managers, senior managers, functional heads and CXO / leadership positions.",
  },
  {
    q: "Does Talentify support leadership hiring?",
    a: "Yes. Leadership hiring is one of our core solutions, covering managers, senior managers, functional heads and CXO-level mandates with a discreet, quality-focused approach.",
  },
  {
    q: "How does the recruitment process work?",
    a: "Our process runs through six stages: Understand, Source, Screen, Shortlist, Coordinate and Close — from requirement understanding through sourcing, screening, shortlisting, interview coordination and offer management to joining follow-up.",
  },
  {
    q: "How can a company share a hiring requirement?",
    a: "Use the 'Share Your Requirement' form on our Employers page, or write to us at hello@talentifyhs.com. Our recruitment specialists will get in touch to understand your requirement in detail.",
  },
  {
    q: "How can candidates submit their resumes?",
    a: "Candidates can use the 'Submit Your Resume' form on our Candidates page. We accept PDF, DOC and DOCX files. Our team will connect you with relevant opportunities across India.",
  },
];

export const TESTIMONIALS = [
  {
    quote: "Client testimonial will be featured here. This space is reserved for feedback from our hiring partners once their testimonials are received.",
    name: "Client Name",
    role: "Designation",
    company: "Company",
  },
  {
    quote: "Client testimonial will be featured here. This space is reserved for feedback from our hiring partners once their testimonials are received.",
    name: "Client Name",
    role: "Designation",
    company: "Company",
  },
  {
    quote: "Client testimonial will be featured here. This space is reserved for feedback from our hiring partners once their testimonials are received.",
    name: "Client Name",
    role: "Designation",
    company: "Company",
  },
];

export const CONTACT = {
  email: "hello@talentifyhs.com",
  phone: "+91 70161 20977",
  phoneRaw: "+917016120977",
  location: "India — PAN India Operations",
  linkedin: "https://www.linkedin.com/company/talentifystaffing",
};
